import { RESTError } from "../core/RESTError";

/**
 * An error that occurs if a system landscape contains multiple systems with different version.
 */
export class SystemVersionsInconsistentError extends RESTError {
  static origin = "/SNP/CX_SWC1_RS_SYS_VER_INCON";
}
